import * as React from 'react';
export default function FooterRow(props) {
  return /*#__PURE__*/React.createElement("tr", props);
}